export { default } from './VerticalCampaignCard'
